// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__TVywH","content":"styles_content__HdHrr","imageWrapper":"styles_imageWrapper__czXKD","divisor":"styles_divisor__H1KS7"};